import { useCallback } from 'react';
import { safeLocalStorage } from './safeStorage';
import { useTriggeredHint } from './useTriggeredHint';
import { OnboardingHintId } from '../constants';

const useOnboardingDialog = (id: OnboardingHintId) => {
  // The "seen" flag now lives on the user object (server-side), keyed by the
  // same `onboarding-<id>` string previously used in localStorage.
  const { hasSeen, record } = useTriggeredHint(`onboarding-${id}`);
  const localStorageDateKey = `onboarding-${id}-date`;

  const markDialogAsSeen = useCallback(() => {
    record();
    // The cadence timestamp stays client-side: the server model is seen-once,
    // and re-show timing belongs to the separate hint-timing ticket.
    safeLocalStorage.setItem(localStorageDateKey, Date.now().toString());
  }, [record, localStorageDateKey]);

  return { isShown: hasSeen, markDialogAsSeen };
};

export default useOnboardingDialog;
